import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ClientInvoicesApiAdapter } from '../adapters/ClientInvoicesApiAdapter';

export const useClientInvoices = (teamId: number) => {
    const apiAdapter = useMemo(() => {
        const httpClient = createHttpClient(apiClientWH);
        return new ClientInvoicesApiAdapter(httpClient);
    }, []);

    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ['client-invoices', teamId],
        queryFn: async () => {
            const response = await apiAdapter.getInvoicesByTeamId(teamId);
            return response;
        },
        staleTime: 2 * 60 * 1000,
        enabled: !!teamId,
    });

    return {
        invoices: data?.data ?? [],
        total: data?.meta?.total ?? 0,
        isLoading,
        error,
        refetch,
    };
};

